/** Prefix shared by the mutation keys of the steps that take a Stripe payment. */
const BILLING_STRIPE_PAYMENT_MUTATION_KEY = '/billing/stripe/payment';

export default BILLING_STRIPE_PAYMENT_MUTATION_KEY;
